export default __webpack_public_path__ + "static/media/reactMovies.61c4e34e.png";